/* The couch. Scatters fur motes over the cushions and lets you vacuum them off
   by dragging. Purely decorative: if this never runs, the section still reads.

   The readout and the buttons deliberately live OUTSIDE the couch box (the couch
   clips its own contents), so every control is looked up on the [data-mo-panel]
   wrapper rather than on the couch element. Looking them up on the couch is what
   used to leave the counter stuck at zero. */
(function () {
  'use strict';

  function build(root) {
    if (root.dataset.moBound) return;
    root.dataset.moBound = '1';

    var panel = (root.closest && root.closest('[data-mo-panel]')) || root.parentElement || root;

    var stage = root.querySelector('[data-mo-stage]');
    var nozzle = root.querySelector('[data-mo-nozzle]');
    var countEl = panel.querySelector('[data-mo-count]');
    var statusEl = panel.querySelector('[data-mo-status]');
    var clearBtn = panel.querySelector('[data-mo-clear]');
    var resetBtn = panel.querySelector('[data-mo-reset]');
    if (!stage) return;

    var total = parseInt(root.dataset.total, 10) || 160;
    var radius = parseInt(root.dataset.radius, 10) || 58;
    var steps = (root.dataset.status || '').split('|');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var hairs = [];
    var removed = 0;
    var timers = [];

    function scatter() {
      var frag = document.createDocumentFragment();
      hairs = [];
      for (var i = 0; i < total; i++) {
        var h = document.createElement('span');
        h.className = 'mo-hair';
        var band = Math.random();
        var top;
        if (band < 0.64) { top = 36 + Math.random() * 56; }        // the seats
        else if (band < 0.9) { top = 7 + Math.random() * 22; }      // the backs
        else { top = 5 + Math.random() * 88; }                      // the arms
        var w = 9 + Math.random() * 13;
        h.style.left = (3 + Math.random() * 94) + '%';
        h.style.top = top + '%';
        h.style.width = w.toFixed(1) + 'px';
        h.style.height = (w * 0.52).toFixed(1) + 'px';
        h.style.marginLeft = (-w / 2).toFixed(1) + 'px';
        // Opacity goes through a custom property, not an inline value: an inline
        // opacity outranks .is-gone{opacity:0} and the mote never fades out.
        h.style.setProperty('--o', (0.5 + Math.random() * 0.45).toFixed(2));
        h.style.setProperty('--r', (Math.random() * 180 - 90).toFixed(0) + 'deg');
        frag.appendChild(h);
        hairs.push(h);
      }
      stage.appendChild(frag);
    }

    function setStatus() {
      if (!statusEl || !steps.length) return;
      var pct = total ? removed / total : 0;
      var idx;
      if (pct <= 0) idx = 0;
      else if (pct >= 1) idx = steps.length - 1;
      else if (pct < 0.35) idx = 1;
      else if (pct < 0.7) idx = 2;
      else idx = 3;
      if (idx > steps.length - 1) idx = steps.length - 1;
      statusEl.textContent = steps[idx] || '';
    }

    function paint() {
      if (countEl) countEl.textContent = removed;
      setStatus();
      panel.classList.toggle('is-dirty', removed > 0);
    }

    function take(h) {
      if (h.dataset.gone) return false;
      h.dataset.gone = '1';
      h.classList.add('is-gone');
      removed++;
      return true;
    }

    function suck(x, y) {
      var r = stage.getBoundingClientRect();
      var changed = false;
      for (var i = 0; i < hairs.length; i++) {
        var h = hairs[i];
        if (h.dataset.gone) continue;
        var hx = (parseFloat(h.style.left) / 100) * r.width;
        var hy = (parseFloat(h.style.top) / 100) * r.height;
        var dx = hx - x;
        var dy = hy - y;
        if (dx * dx + dy * dy < radius * radius) {
          if (take(h)) changed = true;
        }
      }
      if (changed) paint();
    }

    function at(e) {
      var r = stage.getBoundingClientRect();
      var p = e.touches ? e.touches[0] : e;
      var x = p.clientX - r.left;
      var y = p.clientY - r.top;
      if (x < 0 || y < 0 || x > r.width || y > r.height) return null;
      if (nozzle) { nozzle.style.left = x + 'px'; nozzle.style.top = y + 'px'; }
      root.classList.add('is-live', 'is-touched');
      return { x: x, y: y };
    }

    root.addEventListener('mousemove', function (e) {
      var p = at(e);
      if (p) suck(p.x, p.y);
    });
    root.addEventListener('mouseleave', function () { root.classList.remove('is-live'); });

    var sx = 0, sy = 0, sideways = false;
    root.addEventListener('touchstart', function (e) {
      sx = e.touches[0].clientX;
      sy = e.touches[0].clientY;
      sideways = false;
      var p = at(e);
      if (p) suck(p.x, p.y);
    }, { passive: true });

    root.addEventListener('touchmove', function (e) {
      var t = e.touches[0];
      if (!sideways && Math.abs(t.clientX - sx) > Math.abs(t.clientY - sy) + 4) sideways = true;
      if (sideways && e.cancelable) e.preventDefault();
      var p = at(e);
      if (p) suck(p.x, p.y);
    }, { passive: false });

    root.addEventListener('touchend', function () { root.classList.remove('is-live'); }, { passive: true });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        root.classList.add('is-touched');
        hairs.forEach(function (h) {
          if (h.dataset.gone) return;
          // Marked and counted now, not inside the timeout: otherwise a second
          // click re-queues the same motes and the counter runs past the total.
          h.dataset.gone = '1';
          removed++;
          var delay = reduce ? 0 : Math.random() * 650;
          timers.push(setTimeout(function () { h.classList.add('is-gone'); }, delay));
        });
        paint();
      });
    }

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        timers.forEach(clearTimeout);
        timers = [];
        while (stage.firstChild) stage.removeChild(stage.firstChild);
        removed = 0;
        root.classList.remove('is-touched', 'is-live');
        scatter();
        paint();
      });
    }

    scatter();
    paint();
  }

  function init() {
    document.querySelectorAll('[data-mo-sofa]').forEach(build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
